import React, { FC } from 'react';
import { Redirect } from 'react-router';

import LoadingScreen from 'src/shared/components/base/screenLoaders/LoadingScreen';
import { useHasEmployeePermission } from 'src/shared/permissions/useCurrentUserPermissions';

/**
 * Guard that checks if the user has the permission to schedule interviews.
 * Note: Guards should check only one thing. Don't add any other checks to this Guard.
 */
const RPUserHasSchedulerPermissionGuard: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { permission: canSchedule, loading } = useHasEmployeePermission('CAN_SCHEDULE');

  if (loading) {
    return <LoadingScreen />;
  }

  if (!canSchedule) {
    return <Redirect to="/ip" />;
  }

  // Don't add components here, please add components either on the app or on the appropriate Layout component
  return <>{children}</>;
};

export default RPUserHasSchedulerPermissionGuard;
